import React from 'react';
import { Link } from 'react-router-dom';
import Posts from './Posts';
import VideoSection from '../components/VideoSection';
import useLatestVideoUrl from '../hooks/useLatestVideoUrl';
import { TOOLS } from '../lib/tools';

const Home = () => {
  const videoUrl = useLatestVideoUrl();

  return (
    <div className="ff-page ff-page--home">
      <section className="ff-page__section" aria-labelledby="ff-home-tools-title">
        <div className="ff-page__section-head">
          <h1 id="ff-home-tools-title" className="ff-page__section-title ff-home-section-title">
            Tools
          </h1>
        </div>

        <ul className="ff-tool-quick-links ff-tool-quick-links--described" aria-labelledby="ff-home-tools-title">
          {TOOLS.map((tool) => (
            <li key={tool.to}>
              <Link to={tool.to} className="ff-tool-quick-link ff-tool-quick-link--described">
                <span className="ff-tool-quick-link__text">
                  <span className="ff-tool-quick-link__label">{tool.title}</span>
                  <span className="ff-tool-quick-link__copy">{tool.description}</span>
                </span>
                <span className="ff-tool-quick-link__arrow" aria-hidden="true">→</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <VideoSection videoUrl={videoUrl} />

      <section className="ff-page__section" aria-labelledby="ff-home-posts-title">
        <div className="ff-page__section-head">
          <h2 id="ff-home-posts-title" className="ff-page__section-title ff-home-section-title">
            Latest posts
          </h2>
        </div>
        <Posts />
      </section>
    </div>
  );
};

export default Home;
